// Import action types related to city data
import {
  CITY_ARE_LOADING,
  CITY_HAVE_ERROR,
  CITY_FETCH_DATA_SUCCESS,
} from "../actionType";

// Define the initial state for the CityReducer
const initialState = {
  data: [],
  loading: true,
  error: [],
};

// Reducer function to handle city-related actions and update state accordingly
export function CityReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching city data
    case CITY_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when city data is being fetched
    case CITY_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when city data is successfully fetched
    case CITY_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.city, // Update the data state with the fetched city data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
